import { Description } from './Description';
import { Information } from './Information/Information';

export const Project = ({ project , reverse  }) => {
    return (
        <>
            <Description
                subtitle={project.entity}
                title={project.unit}
                text={<p>{project.description}</p>}
                image={project.photo}
                reverse={reverse}
            />
            <Information project={project} />
        </>
    );
};
